import React from 'react'
import { Box, Image, Text, useColorModeValue } from '@chakra-ui/react'

import { getBggGameCoverUrl } from '../Utils'

/** Static tile for drag overlay (not a sortable item). */
export default function GameTilePreview({ item }) {
	const border = useColorModeValue('gray.200', 'whiteAlpha.300')
	const bg = useColorModeValue('white', 'bgg.800')
	const gameLike = item || { name: '', thumbnail: null, image: null }

	return (
		<Box
			borderWidth="1px"
			borderColor={border}
			rounded="lg"
			overflow="hidden"
			bg={bg}
			boxShadow="lg"
			w={{ base: '72px', sm: '88px' }}
			flexShrink={0}
		>
			<Image
				src={getBggGameCoverUrl(gameLike)}
				alt=""
				width="100%"
				height={{ base: '104px', sm: '126px' }}
				objectFit="cover"
				bg="gray.100"
				draggable={false}
			/>
			<Text px={1} py={1} fontSize="10px" fontWeight="600" noOfLines={2} color="gray.700" _dark={{ color: 'gray.200' }}>
				{item?.name || ''}
			</Text>
		</Box>
	)
}
